<template>
  <div>
    <form>
      <!----select stages ----->
      <div class="row">
        <div class="col-md-12">
          <button type="button"
                  class="btn btn-light btn-sm back"
                  @click.prevent="hideTasks()">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h1 v-if="this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="this.protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{protocol.updatedAt.date |
            toLocaleDateTime}}</h1>
          <h3 class="page-sub-title">{{'protocol.checkList' | trans}}
            {{currentStage.title}}: {{currentStage.description}}</h3>
        </div>
      </div>


      <!----------- tasks ------------------->
      <div class="alert alert-secondary mt-2" v-if="tasks">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.stimuluses' | trans}}</h4>
          </div>
          <div class="tasks col-md-12" id="tasks">

            <table class="table table-sm">
              <thead>
              <tr>
                <th>{{'protocol.stimulus_name' | trans}}</th>
                <th>{{'protocol.show_on_stage' | trans}}</th>
                <th v-if="(isCurator || isBCBA) && protocol.assigneeId">{{'protocol.mastered_mand' | trans}}</th>
                <th></th>
              </tr>
              </thead>
              <draggable
                  :list="tasks"
                  ghost-class="ghost"
                  tag="tbody"
                  @start="dragging = true"
                  @end="dragging = false"
                  handle=".drag-btn"
              >
                <tr v-for="task in tasks" :key="task.globalUuid">
                  <td class="name-field">
                    {{task.description}}
                  </td>
                  <td class="table-actions">
                    <mdc-checkbox v-model="task.active" :disabled="task.mastered"/>
                  </td>
                  <td class="table-actions" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                    <mdc-checkbox v-model="task.mastered" :disabled="!task.active"  @change="masteredTask(task)"/>
                  </td>
                  <td class="text-right action-cell">
                    <span class="drag-btn align-top"  v-if="task.active && !task.mastered">draggable</span>
                  </td>
                </tr>
              </draggable>

            </table>


          </div>
          <!----------- tasks ------------------->

          <div class="col-10 col-md-11">
            <mdc-textfield type="text"
                           :label="'protocol.buttons.addStimulus' | trans"
                           name="addTaskReactionItem"
                           :class="{'is-invalid': errors.has('addTaskReactionItem')}"
                           v-validate="'max:1000'"
                           v-model="addTaskReactionItem"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.buttons.addStimulus' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('addTaskReactionItem')">
                      <strong>{{ errors.first('addTaskReactionItem') }}</strong>
                  </span>

          </div>
          <div class="col-2 col-md-1">
            <button type="button"
                    class="btn btn-sm btn-rounded btn-add-grey"
                    @click.prevent="addTask(addTaskReactionItem)">
              <i class="material-icons button-primary btn-fixed">add</i>
            </button>
          </div>

        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-12">
          <div class="box-shadow">


            <div class="form-group row">

              <div class="col-md-5" v-if="taskType">

                <div class="taskTypes" id="taskTypes">
                  <v-select name="taskType"
                            :options="taskTypesNew"
                            label="title"
                            :filterable="false"
                            :clearable="true"
                            v-validate="'required'"
                            data-vv-validate-on="none"
                            :class="{'is-clear is-invalid': !taskType.title}"
                            v-model="taskType"
                            :disabled="disabledChange || disabledTaskType"
                            :on-change="changeTaskType">
                    <template slot="no-options">
                      <div @mousedown.stop="">
                        {{ 'protocol.no_data' | trans }}
                      </div>
                    </template>
                  </v-select>
                  <label class="mdc-floating-label"  :class="{'is-invalid': !taskType.title}">{{'protocol.task_type' |
                    trans}} <sup><mdc-icon class="help_icon" icon="help"  v-tooltip.top-center="msg"></mdc-icon></sup></label>
                  <span class="invalid-feedback"
                        v-if="!taskType.title">
                <strong>{{'protocol.task_type' |
              trans}} {{'validation.required_field' | trans}}</strong>
            </span>
                </div>
              </div>

              <div class="col-md-4" v-if="isBaseColdSample && taskType">
                <div class="taskTypes" id="spoTaskTypes">
                  <v-select name="spoTaskType"
                            :options="spoTaskTypesNew"
                            label="title"
                            :disabled="disabledChange"
                            :class="{'is-clear': !currentStage.generate.type.title}"
                            v-model="currentStage.generate.type"
                            :on-change="changeSpoTaskType">
                    <template slot="no-options">
                      <div @mousedown.stop="">
                        {{ 'protocol.no_data' | trans }}
                      </div>
                    </template>
                  </v-select>
                  <label class="mdc-floating-label">{{'protocol.task_type' |
                    trans}}</label>
                </div>
              </div>

            </div>
            <div class="form-group row" v-if="taskType">
              <div class="col-md-4" v-if="isBaseColdSample">
                <mdc-radio v-model="currentStage.generate.answer" name="radios"
                           :disabled="disabledChange"
                           value="4" :label="'protocol.add_minus_spo' | trans" checked/>
                <mdc-radio v-model="currentStage.generate.answer" name="radios"
                           :disabled="disabledChange"
                           value="3" :label="'protocol.add_plus_spo' | trans"/>
              </div>
            </div>

            <div class="row mb-4" v-if="taskType">
              <div class="col-md-12" v-if="taskType.id !== 1">
                  <mdc-switch v-model="currentStage.isPromptEnabled">
                    {{'protocol.track_change_level' | trans}}
                  </mdc-switch>
                  <hints :hint-list="currentStage.taskPrompts" :hintVisible="currentStage.isPromptEnabled"/>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!---- select task types ----->

      <div class="form-group row">
        <div class="col-md-12">
          <button type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="hideTasks()"
                  :disabled="disabled">
            {{'protocol.buttons.back_to_protocol' | trans}}
          </button>
        </div>
      </div>
    </form>

  </div>

</template>

<script>
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import isUndefined from 'lodash/isUndefined';
  import parseInt from 'lodash/parseInt';
  import forEach from 'lodash/forEach';
  import isNull from 'lodash/isNull';
  import isEmpty from 'lodash/isEmpty';
  import includes from 'lodash/includes';
  import {Validator} from 'vee-validate';
  import forIn from 'lodash/forIn';
  import ConfirmModal from './ConfirmModal';
  import cloneDeep from 'lodash/cloneDeep';
  import Hints from '../../protocols/components/Hints';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import draggable from 'vuedraggable';
  import sortBy from 'lodash/sortBy';
  import map from 'lodash/map';
  import filter from 'lodash/filter';
  import {mapGetters} from 'vuex';
  import trim from 'lodash/trim';


  export default {
    components: {ConfirmModal, Hints, draggable},
    props: [
      'protocol',
      'isNew',
      'taskTypes',
      'selectedTaskTypeTitle',
      'selectedStagesTitle',
      'changeFromClient'],
    data() {
      return {
        apiUrl: '/protocols/',
        disabled: false,
        currentStageIndex: 0,
        currentStageTitle: '',
        currentStage: {},
        selectedStage: {},
        tasks: [],
        selected: {},
        taskType: {},
        tempCurrentStageAttemptCount: null,
        coldSampleIds: [1, 5],
        baseColdSample: 5,
        spoTaskTypes: [],
        disabledChange: false,
        stimulList: [],
        isModalVisible: false,
        isStimulVisible: false,
        intervalId: null,
        dragging: false,
        disabledTaskType: false,
        addTaskReactionItem: null,
        msg: lang.get('protocol.enable_recording')
      };
    },
    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),
      isEmptySelectedStage: function() {
        return isEmpty(this.selectedStage);
      },
      taskTypesNew() {
        return this.taskTypes.filter((item) => {
          return item.title !== this.taskType.title;
        });
      },
      spoTaskTypesNew() {
        return this.spoTaskTypes.filter((item) => {
          return item.title !== this.spoTaskTypes.title;
        });
      },

      isBaseColdSample: {
        get: function() {
          return this.baseColdSample === this.taskType.id;
        },
      },
    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          this.protocolChanged();
        }, 25000);

      });
    },

    methods: {


      masteredTask(task){
        if (task.mastered){
          let taskCurrent =  filter(this.tasks, function(item) {
            return item.globalUuid == task.globalUuid;
          })[0];

          taskCurrent.position = this.tasks.length + 1;

          this.tasks = sortBy(this.tasks, 'position');

          this.reindexTasks();
        }
      },

      reindexTasks: function() {
        this.tasks.forEach(function(item, index) {
          let position = (parseInt(index) + 1);
          item['position'] = parseInt(index);
        });

      },

      getCurrentStageIndex: function(title) {
        this.currentStageIndex = findIndex(this.protocol.stages, (stage) => {
          return stage.title === title;
        });

        return this.currentStageIndex;
      },

      changeTaskType: function(taskType) {
        if (taskType) {
          if (this.currentStage.type !== taskType) {
            this.protocolChanged();
          }
          this.currentStage.type = taskType;
          this.taskType = taskType;

          this.currentStageIndex = this.getCurrentStageIndex(
              this.currentStageTitle);

          if (this.isBaseColdSample) {
            this.setStageGenerate();
          } else {
            this.deleteStageGenerate();
          }



          let tasks = this.tasks;
          let taskCount = tasks.length;
          if (taskCount > 0) {
            for (let i = 0; i < taskCount; i++) {
              this.tasks[i]['typeId'] = this.taskType.id;
            }
          }
        } else {
          this.currentStage.type = {};
          this.taskType =  {};
        }
      },

      changeSpoTaskType: function(taskType) {
        if (taskType) {
          this.protocolChanged();
          this.currentStage.generate.type = taskType;
        }
      },

      addTask: function(addTaskReactionItem) {
        if (!addTaskReactionItem) {
          return;
        }

        let unique = true;

        let taskReactionsList = this.protocol.globalTasks;

        forIn(taskReactionsList, function (stimul) {
          if (trim(stimul.description.toLowerCase()) ===
            trim(addTaskReactionItem.toLowerCase())) {
            unique = false;
          }
        });
        if (unique) {

          let position = parseInt(this.tasks.length) + 1;
          let uuid = UuidGenerator.v4();

          this.tasks.push({
            'position': position,
            'globalUuid': uuid,
            'description': addTaskReactionItem,
            'mastered': false,
            'active': true,
            'target': false
          });

          this.protocol.globalTasks.push({
            'position': position,
            'mastered': false,
            'title': lang.get('protocol.tasks') + ' ' + position,
            'description': addTaskReactionItem,
            'active': false,
            'uuid': uuid
          });

          this.addTaskReactionItem = null;
          this.changeCanPublish();

        } else {
          this.errors.add({
            field: 'addTaskReactionItem',
            msg: lang.get('rotation.unique_stimulus'),
          });
        }
      },


      editProtocol() {
        this.$emit('editProtocol');
      },

      createProtocol() {
        this.$emit('createProtocol');
      },

      changeCanPublish() {
        this.$emit('changeCanPublish');
      },

      protocolChanged() {
        this.$emit('protocolChanged');
      },

      reindexStages: function() {
        this.tasks.forEach(function(item, index) {
          let position = parseInt(index);
          item['position'] = parseInt(index);
        });
      },

      hintsUpdate: function() {
        if (this.currentStage.taskPrompts[2].active || this.currentStage.taskPrompts[3].active || this.currentStage.taskPrompts[4].active || this.currentStage.taskPrompts[5].active){
          this.currentStage.taskPrompts[1].active = false;
        }
      },

      async hideTasks() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result || !this.taskType.title) {
          this.disabled = false;
          return;
        }

        this.hintsUpdate();

        this.$set(this.protocol.stages,this.currentStageIndex, this.currentStage);

        this.reindexTasks();

        this.$set(this.protocol.stages[this.currentStageIndex], 'tasks', filter(this.tasks, function(item) {
          return item.active;
        }));

        this.protocol.stages[this.currentStageIndex].masteredTasks =  filter(this.tasks, function(item) {
          return item.mastered;
        });
        this.protocol.stages[this.currentStageIndex].type= this.taskType;

        this.reindexStages();
        this.$emit('hideTasks');
      },

      setStageGenerate: function() {
        if (!this.currentStage.hasOwnProperty('generate')) {
          this.currentStage['generate'] = {
            type: this.getSpoType(4),
            attempts: this.currentStage.attemptCount,
            answer: '-',
          };
        }

        if (isNull(this.currentStage.generate.type)) {
          this.currentStage.generate.type = this.getSpoType(4);
        }

        if (!isNull(this.currentStage.generate.attempts)) {
          this.currentStage.attemptCount = this.currentStage.generate.attempts;
        }
      },

      deleteStageGenerate: function() {
        if (this.currentStage.hasOwnProperty('generate')) {
          delete this.currentStage.generate;
        }
      },

      getSpoType: function(id) {
        let types = this.spoTaskTypes.filter(function(taskType) {
          return taskType.id === id;
        });

        return types.shift();
      },

    },

    created() {
      if (this.selectedStagesTitle) {
        this.currentStageIndex = this.getCurrentStageIndex(
            this.selectedStagesTitle);
      }

      forEach(this.taskTypes, (type) => {
        if (!(includes(this.coldSampleIds, type.id))) {
          this.spoTaskTypes.push(
              type,
          );
        }
      });

      this.selected = this.protocol.stages[this.currentStageIndex];
      this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
      this.currentStage = cloneDeep(this.protocol.stages[this.currentStageIndex]);

      if (this.currentStage.type){
        if (this.currentStage.type.id === 1 || this.currentStage.type.id === 2){
          this.disabledTaskType = true;
        }
        
        this.taskType = this.currentStage.type;
      }
      if (!this.taskTypes) {
        let index = 0;
        if (this.selectedTaskTypeTitle) {
          index = findIndex(this.taskTypes, (task) => {
            return task.title === this.selectedTaskTypeTitle;
          });
        }
        this.taskType = this.taskTypes[index];
      }

      let taskList = cloneDeep(this.protocol.globalTasks);

      this.tasks = map(taskList, (task) => {
        let currentTask = filter(this.currentStage.tasks, function(item) {
          return item.globalUuid == task.uuid;
        });

        task.active = currentTask.length == 1;
        task.position = currentTask.length ? currentTask[0].position : taskList.length;
        task.globalUuid = task.uuid;
        task.canBeMarkedAsMastered = currentTask.length ? currentTask[0].canBeMarkedAsMastered : false
        task.mastered = filter(this.currentStage.masteredTasks, function(item) {
          return item.globalUuid == task.uuid;
        }).length == 1;
        delete task['uuid'];

        return task;
      });

      this.tasks = sortBy(this.tasks, 'position');

      this.setStageGenerate();

      Validator.extend('unique_task', {
        getMessage: attribute => lang.get('validation.unique_task',
            {attribute}),
        validate: async (task) => {
          let valid;
          let unique = 0;

          forIn(this.tasks, function(item) {
            if (item.description === task) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },

  };
</script>


// WEBPACK FOOTER //
// src/modules/protocols/components/Tasks.vue